import { Navigate, useRouter } from '@tanstack/react-router';
import { useUserStore } from '@/store/useUserStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user } = useUserStore();
  const router = useRouter();

  // If there's no user, redirect to login with the current path as redirect
  if (!user) {
    const currentPath = router.state.location.pathname;
    const currentSearch = router.state.location.search;
    
    // Convert search object to query string if it's an object
    const searchString = typeof currentSearch === 'object' && currentSearch !== null 
      ? '?' + new URLSearchParams(currentSearch as Record<string, string>).toString()
      : typeof currentSearch === 'string' 
      ? currentSearch 
      : '';
    
    const fullPath = currentPath + searchString;
    
    return <Navigate 
      to="/login" 
      search={{ redirect: fullPath !== '/login' ? fullPath : undefined }}
      replace 
    />;
  }

  return <>{children}</>;
};
